/*global define jQuery*/
define('jQPlugins/jquery.single_dbl_click',['jQuery'], function (jQuery) {
	'use strict';

    (function ($) {
		// Author: Gicheol Lee
		// License: MIT
		// References: http://gist.github.com/399624

		var $fn = $.fn;

		// Bind both single click & double click using setTimeout

		$fn.single_dbl_click = function(selector, single_callback, dbl_callback, single_data, dbl_data, timeout) {
			var noSelector = typeof selector !== "string";

			return this.each(function () {
				var self = this,
					clicks = 0,
					mouseX,
					mouseY,
					$this = $(this),
					handler = function (event) {
						var timeoutId;

						event.stopPropagation();
						mouseX = event.pageX;
						mouseY = event.pageY;

						if ($this.data("sdc_timeoutID") === -1) {
							clicks = 0;
						}

						if (++clicks === 1) {
							var firstClickMouseX = mouseX,
								firstClickMouseY = mouseY;

							timeoutId = setTimeout(function () {
								if (clicks === 1) {
									event.data = single_data;
									single_callback.call(self, event);
								} else if (firstClickMouseX === mouseX && firstClickMouseY === mouseY) {
									event.data = dbl_data;
									dbl_callback.call(self, event);
								}
								clicks = 0;
							}, timeout || 300);

							$this.data("sdc_timeoutID", timeoutId);
						}
					},
					args = noSelector ? ["click.single_dbl", handler] : ["click.single_dbl", selector, handler];

				$this.on.apply($this, args);
			});
		};

		// Remove click event handler for clean-up

		$fn.single_dbl_click_off = function() {
			return this.each(function () {
				$(this).off("click.single_dbl");
			});
		};

		// Clear setTimeout when you want to cancel setTimeout

		$fn.single_dbl_click_clear = function() {
			return this.each(function () {
				var $this = $(this),
					timeoutId = $this.data("sdc_timeoutID");

				if (timeoutId > -1) {
					clearTimeout(timeoutId);
					$this.data("sdc_timeoutID", -1);
				}
			});
		};

    }(jQuery));
});
